import React from 'react'

export default function EventData({eventData}) {
  return (
    <div> 
        <div className="table-responsive">
            {eventData && <>
                <table className="table table-bordered">
                    <thead>
                        <th>Symbol</th>
                        <th>Purpose</th>
                        <th>Event Date</th>
                        <th>LTP</th>
                        <th>Open</th>
                        <th>High</th>
                        <th>Low</th>
                        <th>Volume</th>
                    </thead>
                    <tbody>
                    {eventData.map((item, key) => ( 
                                      <tr key={`eventData-${key}`}>
                                        <td>{item.symbol} </td>
                                        <td>{item.purpose} </td>
                                        <td>{item.evnet_date}</td>
                                        <td>{item.l}</td> 
                                        <td>{item.op}</td>
                                        <td>{item.hi}</td>
                                        <td>{item.lo}</td>
                                        <td>{item.vo}</td>
                                      </tr> 
                                  ))} 
                    </tbody>
                </table>
            </>}
        </div>
    </div>
  )
}
